var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-page" },
    [
      _c("Header"),
      _c("Menulist"),
      _c("div", { staticClass: "page-main" }, [
        _c(
          "div",
          {
            staticClass: "stat-row",
            class:
              "stat-row--" +
              (_vm.carriers.length > 3 ? 3 : _vm.carriers.length),
          },
          [
            _vm._l(_vm.carriers, function (c) {
              return _c(
                "div",
                {
                  key: c.key,
                  staticClass: "stat-card",
                  style: { borderLeftColor: c.color },
                },
                [
                  _c("div", { staticClass: "stat-card__head" }, [
                    _c("img", {
                      staticClass: "stat-card__logo",
                      attrs: { src: c.logo, alt: "" },
                    }),
                    _c(
                      "span",
                      {
                        staticClass: "stat-card__name",
                        style: { color: c.color },
                      },
                      [_vm._v(_vm._s(c.name))]
                    ),
                  ]),
                  _c("div", { staticClass: "stat-card__total" }, [
                    _c("span", { staticClass: "stat-card__total-value" }, [
                      _c("b", { style: { color: c.color } }, [
                        _vm._v(_vm._s(c.info.total)),
                      ]),
                      _vm._v(" 张"),
                    ]),
                  ]),
                  _c("div", { staticClass: "stat-card__list" }, [
                    _c("div", { staticClass: "stat-item" }, [
                      _c("i", { staticStyle: { background: "#6dd400" } }),
                      _vm._v("正常"),
                      _c("b", [_vm._v(_vm._s(c.info.zcsl || 0))]),
                    ]),
                    _vm._m(0, true),
                    _c("div", { staticClass: "stat-item" }, [
                      _c("i", { staticStyle: { background: "#0091ff" } }),
                      _vm._v("停机"),
                      _c("b", [_vm._v(_vm._s(c.info.gqsl || 0))]),
                    ]),
                    _vm._m(1, true),
                  ]),
                ]
              )
            }),
            _vm.carriers.length == 0
              ? _c("div", { staticClass: "stat-empty" }, [
                  _vm._v("暂无可统计的网卡数据"),
                ])
              : _vm._e(),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "chart-row" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c(
                  "el-col",
                  { attrs: { xs: 24, md: 12 } },
                  [
                    _c(
                      "el-card",
                      { staticClass: "data-card" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "card-head",
                            attrs: { slot: "header" },
                            slot: "header",
                          },
                          [_c("span", [_vm._v("终端统计")])]
                        ),
                        _c("Echarts", {
                          staticStyle: { height: "260px" },
                          attrs: { option: _vm.option },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { xs: 24, md: 12 } },
                  [
                    _c(
                      "el-card",
                      { staticClass: "data-card" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "card-head",
                            attrs: { slot: "header" },
                            slot: "header",
                          },
                          [_c("span", [_vm._v("流量监控 Top5")])]
                        ),
                        _c("Echarts", {
                          staticStyle: { height: "260px" },
                          attrs: { option: _vm.options },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "news-row" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20, type: "flex" } },
              [
                _c(
                  "el-col",
                  { attrs: { xs: 24, md: 12 } },
                  [
                    _c("el-card", { staticClass: "data-card" }, [
                      _c(
                        "div",
                        {
                          staticClass: "card-head",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [_vm._v("通知公告")]),
                          _c(
                            "el-button",
                            {
                              staticClass: "card-head__more",
                              attrs: { type: "text" },
                              on: { click: _vm.noticelist },
                            },
                            [_vm._v("更多")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "news-list" },
                        [
                          _vm._l(_vm.notice, function (o) {
                            return _c(
                              "div",
                              {
                                key: o.id || o.title,
                                staticClass: "news-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.clicknotice(o)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "news-item__title" },
                                  [_vm._v(_vm._s(o.title))]
                                ),
                                _c("span", { staticClass: "news-item__time" }, [
                                  _vm._v(_vm._s(o.addtime)),
                                ]),
                              ]
                            )
                          }),
                          _vm.notice.length == 0
                            ? _c("div", { staticClass: "news-empty" }, [
                                _vm._v("暂无信息"),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { xs: 24, md: 12 } },
                  [
                    _c("el-card", { staticClass: "data-card" }, [
                      _c(
                        "div",
                        {
                          staticClass: "card-head",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [_vm._v("常见问题")]),
                          _c(
                            "el-button",
                            {
                              staticClass: "card-head__more",
                              attrs: { type: "text" },
                              on: { click: _vm.knowledgelist },
                            },
                            [_vm._v("更多")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "news-list" },
                        [
                          _vm._l(_vm.problem, function (o) {
                            return _c(
                              "div",
                              {
                                key: o.id || o.answer,
                                staticClass: "news-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.clickknowledge(o)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "news-item__title" },
                                  [_vm._v(_vm._s(o.answer))]
                                ),
                                _c("span", { staticClass: "news-item__time" }, [
                                  _vm._v(_vm._s(o.addtime)),
                                ]),
                              ]
                            )
                          }),
                          _vm.problem.length == 0
                            ? _c("div", { staticClass: "news-empty" }, [
                                _vm._v("暂无信息"),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("Footer"),
      _c(
        "el-dialog",
        {
          attrs: { title: "通知公告", visible: _vm.noticestatus, width: "60%" },
          on: {
            "update:visible": function ($event) {
              _vm.noticestatus = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-row" }, [
            _c("b", [_vm._v("标题：")]),
            _c("span", [_vm._v(_vm._s(_vm.noticecontent.title))]),
          ]),
          _c("div", { staticClass: "dialog-row" }, [
            _c("b", [_vm._v("时间：")]),
            _c("span", [_vm._v(_vm._s(_vm.noticecontent.addtime))]),
          ]),
          _c("div", { staticClass: "dialog-block" }, [
            _c("b", [_vm._v("内容")]),
            _c("div", {
              staticClass: "dialog-content",
              domProps: { innerHTML: _vm._s(_vm.noticecontent.content) },
            }),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.noticestatus = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "问题解答",
            visible: _vm.knowledgestatus,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.knowledgestatus = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-row" }, [
            _c("b", [_vm._v("标题：")]),
            _c("span", [_vm._v(_vm._s(_vm.knowledgecontent.answer))]),
          ]),
          _c("div", { staticClass: "dialog-row" }, [
            _c("b", [_vm._v("时间：")]),
            _c("span", [_vm._v(_vm._s(_vm.knowledgecontent.addtime))]),
          ]),
          _c("div", { staticClass: "dialog-block" }, [
            _c("b", [_vm._v("内容")]),
            _c("div", {
              staticClass: "dialog-content",
              domProps: { innerHTML: _vm._s(_vm.knowledgecontent.question) },
            }),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.knowledgestatus = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.dialogVisible,
            width: "420px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-tip" }, [
            _vm._v("请完善开票信息，补全再进行下一步！"),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.NetUserinfo()
                    },
                  },
                },
                [_vm._v("去完善")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-item" }, [
      _c("i", { staticStyle: { background: "#e02020" } }),
      _vm._v("测试"),
      _c("b", [_vm._v("0")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-item" }, [
      _c("i", { staticStyle: { background: "#6d7278" } }),
      _vm._v("其他"),
      _c("b", [_vm._v("0")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }